var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimesheet(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5E5E66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0006 2C7.87868 2 5.84371 2.84291 4.34331 4.34331C2.84291 5.84371 2 7.87868 2 10.0006C2 12.1224 2.84291 14.1574 4.34331 15.6578C5.84371 17.1582 7.87868 18.0011 10.0006 18.0011C12.1224 18.0011 14.1574 17.1582 15.6578 15.6578C17.1582 14.1574 18.0011 12.1224 18.0011 10.0006C18.0011 7.87868 17.1582 5.84371 15.6578 4.34331C14.1574 2.84291 12.1224 2 10.0006 2ZM5.40397 5.40397C6.62306 4.18488 8.2765 3.5 10.0006 3.5C11.7246 3.5 13.3781 4.18488 14.5971 5.40397C15.8162 6.62306 16.5011 8.2765 16.5011 10.0006C16.5011 11.7246 15.8162 13.3781 14.5971 14.5971C13.3781 15.8162 11.7246 16.5011 10.0006 16.5011C8.2765 16.5011 6.62306 15.8162 5.40397 14.5971C4.18488 13.3781 3.5 11.7246 3.5 10.0006C3.5 8.2765 4.18488 6.62306 5.40397 5.40397ZM9.84375 6C10.3097 6 10.6875 6.37776 10.6875 6.84375V10.35H13.1062C13.5722 10.35 13.95 10.7278 13.95 11.1938C13.95 11.6597 13.5722 12.0375 13.1062 12.0375H9.84375C9.37776 12.0375 9 11.6597 9 11.1938V6.84375C9 6.37776 9.37776 6 9.84375 6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheet);
export default __webpack_public_path__ + "static/media/timesheet.95356c2b.svg";
export { ForwardRef as ReactComponent };